module.exports = __webpack_public_path__ + "static/media/Icon_moneygreen.8f410580.svg";